import { CUSTOM_CONSTANTS } from "Constants";

export const mapContractRecord = (item = {}) => ({
  id: item?.id || "--",
  name: item?.title || "--",
  reference: item?.reference_number || "--",
  type: item?.type || "--",
  status: (item?.status || "draft").toString().toLowerCase(),
  counterparty: item?.counterparty_name || null,
  counterpartyEmail: item?.counterparty_email || null,
  owner: item?.owner_id || null,
  department: item?.department || null,
  startDate: item?.start_date || null,
  endDate: item?.end_date || null,
  value: item?.value_amount !== undefined && item?.value_amount !== null
    ? Number(item.value_amount)
    : null,
  valueCurrency: item?.value_currency || CUSTOM_CONSTANTS.BASE_CURRENCY,
  autoRenew: Boolean(item?.auto_renew),
  noticePeriod:
    item?.renewal_notice_day !== undefined && item?.renewal_notice_day !== null
      ? `${item.renewal_notice_day} days`
      : null,
  governingLaw: item?.governing_law || null,
  riskScore: item?.risk_score ?? null,
  template: item?.template_name || null,
  paymentTerms: item?.payment_terms || null,
  clauses: item?.clauses_count ?? 0,
  approvals: item?.approvals_count ?? 0,
  signatures: item?.signatures_count ?? 0,
  createdAt: item?.created_at || null,
  updatedAt: item?.updated_at || null,
  raw: item,
});
